import waitFor from '../helpers/waitfor';
import amaLog, { amaAlert } from '../helpers/log';
import loadScript from './loadScript';
import { AdsConfigJson } from '../config/platform';
import { loadConfig } from '../config/platform';
import { getModules } from '../config/modules';
import { isVideoPage, isSeOcelot } from '../config/domain';
import { useTopAds } from '../config/platform';
import { AD_PLACEMENT_ATTRIBUTE } from '../placement/placement';
import { pbjs } from '../prebid/index';
import { timeFor } from '../helpers/time';

let demandManagerLoaded = false;
const adPlacementSelector = `div[${AD_PLACEMENT_ATTRIBUTE}]`;

export const resourceTimeout = 20000;

const isDemandManagerLoaded = () => demandManagerLoaded;

const isAnyPlacementsLoaded = () => !!document.querySelector<HTMLElement>(adPlacementSelector);

const loadTopAdPlacement = async (topAdTarget: string) => {  
  if ( isSeOcelot()) {

    amaLog('loadTopAdPlacement ...', topAdTarget);

    // ToDo: Move top-ad placement handling to platform in se-ocelot  
    const isApp = window.location.search.includes('allerapp=1');
    if (!isApp) {

      let topAdElement = document.createElement('div');
      topAdElement.id = `${topAdTarget}`;
      topAdElement.setAttribute('data-aller-ad-placement', 'top_ad');

      await waitFor(() => typeof window?.document?.body?.insertBefore !== 'undefined', { timeout: 5000, errorMessage: `Timeout: window.document.body missing. top_ad is not injected` }).then(() => {

        window.document.body.insertBefore(topAdElement, window.document.body.firstChild);
      });              
    }
  }
}

export const loadDemandManager = async () => {

  const { prebidScript, usePlacementCheck, useLoadDMByAdsLib } = getModules();

  if ( useLoadDMByAdsLib) {

    amaLog(`Start load DM ${timeFor('loadDMstart')}`);

    amaLog(`DemandManager loading by ads-lib ...`);

    amaLog('usePlacementCheck', usePlacementCheck);

    if ( usePlacementCheck ) {

      if (!isAnyPlacementsLoaded() && !isVideoPage()) {
        amaLog(`Ads:: Wait for Placement Wrapper to be loaded ...`);
        await waitFor(isAnyPlacementsLoaded, {
          timeout: 20000,
          errorMessage: `Timeout: Placementwrappers are missing `,
        });
      }
      amaLog('Ads:: Placement Wrapper is loaded');
    }

    try {
      loadScript(prebidScript, { 
        async: true,
        defer: false,
        referrerpolicy: "strict-origin-when-cross-origin"
      }).then( () => {
        demandManagerLoaded = true;
        amaLog('DemandManagerLoaded');
      });  
    } catch (error) {
      console.error('DemandManager failed to Load', error);
      demandManagerLoaded = true;
    }  
  } else {
    amaLog('DemandManager not loaded by ads-lib');
    demandManagerLoaded = true;
  }
};

let loadingDmPending = false;    

export const handleDemandManager = async () => {

  amaLog(`handleDemandManager ${timeFor('loadDM')}`);

  pbjs.que.push( () => {
    amaLog(`prebid pbjs.que ready ${timeFor('prebidPbjsQueReady')}`);
  });

  if(!loadingDmPending) {
    loadingDmPending = true;

    loadDemandManager();
  }
  
  await waitFor(isDemandManagerLoaded, {
    timeout: 10000,
    errorMessage: `Timeout: Waiting for dm to be loaded `
  });
  amaLog(`DM loaded ${timeFor('loadDM')}`);

  pbjs.onEvent?.('bidRequested', (bidData:any) => {

    const consent = bidData.gdprConsent;
    const bidder = `${bidData.bidderCode}`;
    if(!(consent?.gdprApplies && typeof consent?.consentString !== 'undefined')) {
      amaAlert(`prebid pbjs.onEvent(bidRequested) ${bidder} ${timeFor(bidder)} - Consent missing!  `, bidData);
    }
  });
}

export const initAdResources = async (parsedConfig: AdsConfigJson) => {

  amaLog('initAdResources ...');

  // Load platformConfig if available
  const config = loadConfig(parsedConfig);

  if(useTopAds()) {
    const { topAdTarget = `top_ad-${window.ama?.adsUniqueId || window.adsUniqueId}`} = parsedConfig;

    loadTopAdPlacement(topAdTarget);  
  }

  return config;
};

export const tcfApiLoaded = async () => {

  amaLog('waitFor tcfApiLoaded ...');

  return await waitFor(() => typeof window?.__tcfapi !== 'undefined', { timeout: resourceTimeout, errorMessage: `Timeout: window.__tcfapi not available ` }).then(() => {
    amaLog('tcfApi is loaded');
  });
};

